import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./NewValueForm.css";

function NewValueForm() {
  const [title, setTitle] = useState("");
  const [titleEnglish, setTitleEnglish] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionEnglish, setDescriptionEnglish] = useState("");
  const [english, setEnglish] = useState(false);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }
    }
    fetch();
  }, [state.language]);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/values`,
        data: {
          title: title,
          titleEnglish: titleEnglish,
          description: description,
          descriptionEnglish: descriptionEnglish,
          organization: state.organization,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/values");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleTitleChange = (evt) => {
    setTitle(evt.target.value);
  };

  const handleDescriptionChange = (evt) => {
    setDescription(evt.target.value);
  };

  const handleTitleEnglishChange = (evt) => {
    setTitleEnglish(evt.target.value);
  };

  const handleDescriptionEnglishChange = (evt) => {
    setDescriptionEnglish(evt.target.value);
  };

  const activateEnglish = () => {
    setEnglish(true);
  };

  return (
    <Container fluid>
      <Row>
        <Col lg={11} className="new-account-header">
          <h2>{t("Reconocimientos.Valores.Valor.NewForm.Titulo")}</h2>
        </Col>
        <Col lg={1} className="new-scale-header mb-2">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faList} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={activateEnglish}>
                <FontAwesomeIcon icon={faLanguage} /> English
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row>
        <Col className="new-account-form">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Título</Form.Label>
              <Form.Control type="text" onChange={handleTitleChange} />
            </Form.Group>
            {english ? (
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control type="text" onChange={handleTitleEnglishChange} />
              </Form.Group>
            ) : (
              <></>
            )}
            <Form.Group className="mb-3">
              <Form.Label>Descripción</Form.Label>
              <Form.Control type="text" onChange={handleDescriptionChange} />
            </Form.Group>
            {english ? (
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleDescriptionEnglishChange}
                />
              </Form.Group>
            ) : (
              <></>
            )}
            <Button className="primary" onClick={handleSubmit}>
              {t("Reconocimientos.Valores.Valor.NewForm.Guardar")}
            </Button>
            <Link to="/values">
              <Button className="danger">
                {t("Reconocimientos.Valores.Valor.NewForm.Cancelar")}
              </Button>
            </Link>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default NewValueForm;
